/* jshint esversion: 6 */

import firebase from "firebase";
import "firebase/firestore";
import "firebase/auth";
import "firebase/storage";

// firebase init goes here
const config = {
    apiKey: "AIzaSyBvnjN_MGm9u7FDz4qDqKqxx5N6KCsq9uU",
    authDomain: "lsextraescolares-81598.firebaseapp.com",
    databaseURL: "https://lsextraescolares-81598.firebaseio.com",
    projectId: "lsextraescolares-81598",
    storageBucket: "lsextraescolares-81598.appspot.com",
    messagingSenderId: "989853469384",
    appId: "1:989853469384:web:7565f17902f26a5822b3fd",
    measurementId: "G-R0RLVQHQKV"
};
firebase.initializeApp(config);

// firebase utils
const db = firebase.firestore();
const fs = firebase.firestore;
const auth = firebase.auth();
const local = firebase.auth.Auth.Persistence.LOCAL;
const currentUser = auth.currentUser;
const storage = firebase.storage().ref();

// help functions
const newId = function () {
    let chars = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    let id = "";
    for (let i = 0; i < 30; i++) {
        id += chars[parseInt(Math.floor(chars.length * Math.random()))];
    }
    return id;
};

const indexOf = function (a, f, v) {
    let index = -1;
    for (let i = 0; i < a.length; i++) {
        if (a[i][f] === v) {
            index = i;
            break;
        }
    }
    return index;
};

const normalize = function (str) {
    var theString = str.toLowerCase();
    return theString.replace(/[áàäâéèëêíìïîóòöôúùüûñç]/gi, (x) => {
        if ("áàäâ".indexOf(x) > -1) return "a";
        if ("éèëê".indexOf(x) > -1) return "e";
        if ("íìïî".indexOf(x) > -1) return "i";
        if ("óòöô".indexOf(x) > -1) return "o";
        if ("úùüû".indexOf(x) > -1) return "u";
        if (x === "ñ") return "nzzz";
        if (x === "ç") return "czzz";
    });
};

// date issue fix according to firebase
const settings = {};
db.settings(settings);

// firebase collections
const activities = db.collection("activities");
const students = db.collection("students");
const tokens = db.collection("tokens");
const messages = db.collection("messages");
const properties = db.collection("properties");

export {
    db,
    fs,
    auth,
    local,
    currentUser,
    storage,
    activities,
    students,
    tokens,
    messages,
    properties,
    newId,
    indexOf,
    normalize,
};